import { FC, useMemo } from "react"
import { IToothIPRData } from "./index"
import Polyline from "./Polyline"
import "./scss/MyUpPolyline.scss"

interface IProps {
  toothIPRData: IToothIPRData
}
const MyUpPolyline: FC<IProps> = ({ toothIPRData }) => {
  const pl = 4
  const itemWidth = 50
  const width = 850
  const { iprURToothDataMemo, iprULToothDataMemo } = toothIPRData
  const toothPos = [
    155, 198, 235, 265, 300, 330, 357, 390, 425, 453, 480, 515, 545, 585, 625,
    660,
  ]
  const getUpList = useMemo(() => {
    const upList = [...iprURToothDataMemo, ...iprULToothDataMemo]
    const isNotMissingData = upList.filter((item) => !item.isMissingTooth)
    const findIndexs = upList
      .map((item, index) => {
        if (item.isMissingTooth) return index
      })
      .filter((item) => item !== undefined)
    const toothPosMap = toothPos.filter(
      (item, index) => !findIndexs.includes(index),
    )
    const posData = isNotMissingData.map((item, index) => {
      const left =
        itemWidth * index +
        pl +
        ((width - itemWidth * isNotMissingData.length) /
          (isNotMissingData.length - 1)) *
          index

      return {
        ...item,
        point: [left, 2, toothPosMap[index], 50, toothPosMap[index], 75],
      }
    })
    return posData
  }, [toothIPRData.iprURToothDataMemo, toothIPRData.iprULToothDataMemo])

  return (
    <div className="my-up-polyline">
      {getUpList.length > 0 &&
        getUpList.map((item, index) => {
          return (
            <div key={index} className="item-polyline">
              <Polyline point={item.point} />
            </div>
          )
        })}
    </div>
  )
}

export default MyUpPolyline
